export default __webpack_public_path__ + "static/media/logo_secondary_white.8379fdf6.png";